import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import type { MouseEvent } from 'react';
import { Button, Icon } from '@ics-portal/guardian';
import LargeLogo from '@components/_atoms/logos/LargeLogo';
import { loginPopupRequest } from '@auth/msal/auth-config';
import s from './welcome-page.module.scss';

export default function WelcomePage() {
    const { instance, accounts, inProgress } = useMsal();

    const handleOnLogin = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        if (inProgress === InteractionStatus.None && accounts.length === 0) {
            void instance.loginPopup(loginPopupRequest);
        }
    };

    const isLoggingIn = inProgress === InteractionStatus.Login;

    return (
        <div className={s.container}>
            <div
                className={`${s.content} flex flex-column gap-6 justify-content-center`}
                style={{ maxWidth: '24.25rem' }}
            >
                <LargeLogo className={s.logo} />
                <p className="text-body text-white px-md text-center">
                    Welcome to Siemens Energy Industrial Cybersecurity Portal,
                    use your Siemens Energy credentials to log in.
                </p>
                <div className={s.divider} />
                <Button
                    className={s.button}
                    disabled={isLoggingIn}
                    label="Log in to ICS portal"
                    onClick={handleOnLogin}
                    icon={<Icon name="arrow_right_alt" />}
                    iconPos="right"
                />
            </div>
        </div>
    );
}
